<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid" style="background: #F0F0F0;">
    <div class="row">
      <div class="store-head">
        <div class="back-link" @click="$router.back()">
          <i class="fas fa-chevron-left"></i>
        </div>
        <div class="category-title">
          <div style="margin-top: 16px; font-size: 20px;"> {{ $t('SELECT_FRIEND') }}</div>
        </div>
      </div>
    </div>
    <div class="row mt-3" v-if="showList">
      <div class="col-lg-12" v-for="friend in friendList" :key="friend.user_id">
        <div class="bcs-content d-flex justify-content-between align-items-center"
             :class="{'selected-friend': selectFriendId === friend.user_id}"
             @click="selectFriend(friend.user_id)">
          <div class="d-flex align-items-center">
            <img :src="friend.image_url"
                 class="rounded-circle"
                 width="50" height="50"
                 :alt="friend.name"/>

            <div class="d-flex flex-column m-lg-3">
              <p class="pat-name">{{ friend.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3" v-else>
      <div class="col-lg-12">
        <div class="d-flex justify-content-center align-items-center vh-100">
          <span class="nothing-found"> {{ $t('YOU_HAVE_NO_FRIENDS') }}  </span>
        </div>
      </div>
    </div>
    <div class="row" v-if="String(selectFriendId).length">
      <div class="d-flex justify-content-center fixed-bottom challenge-footer-fix">
        <argon-button color="danger"
                      variant="gradient"
                      class="my-4 mb-1 me-2 challenge-btn"
                      @click="challengeFriend">
          {{ $t('NEXT') }}
        </argon-button>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/views/components/Loader";
import {sendRequest} from "@/http/axios.method";
import ArgonButton from "@/components/ArgonButton";
import _ from "lodash";

export default {
  name: "SelectFriend",
  components: {
    Loader,
    ArgonButton
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      showList: false,
      friendList: [],
      selectFriendId: '',
    }
  },
  created() {
    this.getFriendList();
  },
  methods: {
    getFriendList() {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/friends', {type: "friends"}, this.config)
          .then( response => {
            this.loaderActive = false;
            this.friendList = response.data.friend_list;
            this.showList = ! _.isEmpty(this.friendList)
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    selectFriend(friend_id) {
      if (this.selectFriendId === friend_id) {
        this.selectFriendId = '';
      } else {
        this.selectFriendId = friend_id;
      }

    },
    challengeFriend() {
      this.$router.push({path: "/challenge-friend", query: {friend_id: this.selectFriendId}})
    }
  },
}
</script>

<style scoped>

</style>
